import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
// import { endPoints } from "../../config/end-points";

// import "./login.css";
import Login from "./pages/ForgotPassword";
import ForgotPassword from "./pages/Login";
const Auth = () => {
  const [toggleClass, setToggleClass] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const passwordPanel = () => {
    history.push("/forgot_password");
  };
  
  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  const meta_data = useSelector(state => state.auth.product.meta_data)

  const favlogo = meta_data && JSON.parse(meta_data).subdomainFavicon ? JSON.parse(meta_data).subdomainFavicon : '';

  useEffect(() => {
    if (location.pathname === "/forgot_password") {
      setToggleClass("right-panel-active");
      document.title = `${subdomain_name ? subdomain_name : 'Engageleads'} | Forgot Password`;
    } else {
      document.title = `${subdomain_name ? subdomain_name : 'Engageleads'} | Login`;
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      // link.href = favlogo;
      if( favlogo !== '' ){
        link.href = favlogo;
      }
    }

    return () => {};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location,subdomain_name]);

  const loginPanel = () => {
    history.push("/login");

    setToggleClass(null);
  };
  return (
    <div className="login_m">
      <div className={`container ${toggleClass}`} id="container">
        <div className="overlay-container">
          <div className="overlay">
            <div className="overlay-panel overlay-left">
              <h1>Welcome Back!</h1>
              <p>
                To keep connected with us please login with your personal info
              </p>
              <button className="ghost" onClick={loginPanel} id="signIn">
                Sign In
              </button>
            </div>
            <div className="overlay-panel overlay-right">
              <h1>Hello, Friend!</h1>
              <p>Enter your personal details and start {subdomain_name} journey with us</p>
              <button className="ghost" onClick={passwordPanel} id="signUp">
                Forgot Password
              </button>
            </div>
          </div>
        </div>
        <div className="form-container sign-up-container">
          <Login />
        </div>
        <div className="form-container sign-in-container">
          <ForgotPassword />
        </div>
      </div>
    </div>
  );
};

export default Auth;
